import { useState, useCallback } from 'react';
import { showAlert } from '../redux/alertSlice';
import { SEVERITIES } from '../data/constants';
import { useDispatch } from 'react-redux';
import { logHandledError } from '../utils/errorLogger';
import { toUserMessage } from '../utils/userFacingError';

type ApiFunction<TParams, TResult> = (params: TParams) => Promise<TResult>;

const useApi = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const dispatch = useDispatch();
  
   const executeApi = useCallback(async <TParams, TResult>(
    apiFunction: ApiFunction<TParams, TResult>,
    params: TParams
  ): Promise<TResult | null> => {
    setLoading(true);
    setError(null);

    try {
      const result = await apiFunction(params);
      return result;
    } catch (err) {
        const message = (err as Error).message;
        setError(message);
        // Handled here, so it never reaches ErrorBoundary or
        // window.onunhandledrejection — log it or it is lost to the Error Log.
        logHandledError(message, (err as Error).stack ?? "");
        // Bug 79203: the alert gets the user-facing sentence, never the raw message —
        // that is how "s.forEach is not a function" and "Request failed with status code 500"
        // reached the popup. The raw message is still logged, one line above.
         dispatch(
                showAlert({
                  message: toUserMessage(err),
                  severity: SEVERITIES.ERROR,
                })
              );
        return null;
      } finally {
        setLoading(false);
      }
    }, [dispatch]);
  

    return { loading, error, executeApi };
};

export default useApi;

